import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App';

AOS.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </>
);